import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';
import { di } from 'react-magnetic-di';
import { css } from '@emotion/react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import useRelatedUrls from '../../../../../state/hooks/use-related-urls';
import { RelatedUrlsBlockErroredView } from './errored';
import { RelatedUrlsResolvedView } from './resolved';
import { RelatedUrlsBlockResolvingView } from './resolving';
import { fireRelatedLinksLoadedEvent } from './analytics';
/**
 * Represents a block to display related resources of a url
 */
const RelatedUrlsBlock = ({
  testId = 'smart-block-related-urls',
  url,
  renderers,
  ...blockProps
}) => {
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const [loadingRelatedUrls, setLoadingRelatedUrls] = useState(true);
  const [err, setErr] = useState();
  const [relatedUrls, setRelatedUrls] = useState();
  const getRelatedUrls = useRelatedUrls();
  useEffect(() => {
    const fetchRelatedUrls = async () => {
      try {
        var _relUrls$resolvedResu, _relUrls$resolvedResu2;
        const relUrls = await getRelatedUrls(url);
        setRelatedUrls(relUrls);

        /**
         * Fire TrackRelatedLinksLoadedEvent
         */
        fireRelatedLinksLoadedEvent(createAnalyticsEvent)({
          relatedLinksCount: (_relUrls$resolvedResu = (_relUrls$resolvedResu2 = relUrls.resolvedResults) === null || _relUrls$resolvedResu2 === void 0 ? void 0 : _relUrls$resolvedResu2.length) !== null && _relUrls$resolvedResu !== void 0 ? _relUrls$resolvedResu : 0
        });
      } catch (error) {
        setErr(error);
      }
      setLoadingRelatedUrls(false);
    };
    fetchRelatedUrls();
  }, [createAnalyticsEvent, getRelatedUrls, url]);
  if (loadingRelatedUrls) {
    return /*#__PURE__*/React.createElement(RelatedUrlsBlockResolvingView, _extends({
      testId: `${testId}-resolving-view`
    }, blockProps));
  }
  if (relatedUrls) {
    return /*#__PURE__*/React.createElement(RelatedUrlsResolvedView, _extends({
      renderers: renderers,
      overrideCss: css({
        minHeight: '1.55rem'
      }),
      testId: `${testId}-resolved-view`,
      relatedUrlsResponse: relatedUrls
    }, blockProps));
  }
  return /*#__PURE__*/React.createElement(RelatedUrlsBlockErroredView, _extends({
    err: err,
    testId: `${testId}-errored-view`
  }, blockProps));
};
export default RelatedUrlsBlock;